<template>
	<div id="Loading">
		<vue-snotify></vue-snotify>
		<div class="text-center">
			<div class="card">
				<div class="card-body p-4 p-sm-5">
					<p class="lead mt-4 text-800 font-sans-serif fw-semi-bold w-md-75 w-xl-100 mx-auto">
						{{ message }} <span class="text-primary pointer" @click="showChangePasswordModalComponent" v-if="changePassword">aquí</span>
						<change-password-modal-component
							ref="changePasswordModalComponent"
							message="Por seguridad tiene que cambiar su contraseña"
							@actionPasswordChanged="passwordChanged"></change-password-modal-component>
					</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import mixin from '@/mixins'
	import axiosAction from '@/mixins/axiosAction.js'
	import commands from '@/mixins/commands'

	import ChangePasswordModalComponent from '@/components/ChangePasswordModalComponent.vue'

	export default {
		name: 'Loading',
		mixins: [mixin, axiosAction, commands],
		data() {
			return {
				message: '',
				changePassword: false			}
		},
		components: {
			'change-password-modal-component': ChangePasswordModalComponent,
		},
		computed: {
		},
		methods: {
			initLoading() {
				this.checkUser()
			},
			resultAxiosLocal(responseLocal, response) {
				switch(responseLocal) {
					case 'checkUserResult': this.checkUserResult(response); break;
					default: console.log('Acción no determinada despues de la consulta (' + responseLocal + ')'); break;
				}
			},
			checkUser() {
				this.message = 'Estamos cargando su información de Perfil . . .'
				let url = this.getApiBackend + 'auth/checkconection'
				this.axiosActionIS(url, 'GET', 'checkUserResult')
			},
			checkUserResult(response) {
				if(response.data.success == true) {
					if(response.data.auth.status_id == 1) {
						this.setInitialized(true)
						this.setUser(response.data.auth)
						this.setToken(localStorage.getItem('token'))
						console.log('Se recuperó con exito los datos del usuario!!!')
						if(response.data.auth.change_password == 1) {
							this.changePassword = true
							this.message = response.data.auth.name + ' por seguridad tiene que cambiar su contraseña'
							this.$refs.changePasswordModalComponent.$refs.btnShowChangePasswordModalComponent.click()
						} else {
							this.getMenus()
						}
					} else {
						console.clear()
						console.log('Disabled User')
						this.$router.push('/unauthorized')	
					}
				} else {
					console.clear()
					this.$router.push('/unauthorized')
				}
			},
			errorHttpHandling(response) {
				console.log('Error!!!', response)
				this.$router.push('/unauthorized')
			},
			getMenuFatorites() {
				this.message = 'Estamos cargando Favoritos . . .'
				this.axios.get(this.getApiBackend + 'auth/getMenuFatorite', {
						headers: this.getHeaders
					})
					.then(response => {
						console.log('Se recuperó con exito los favoritos!!!')
						this.getCommandsByTypeLocal()
					})
					.catch(error => {
						console.log(error)
					})
			},
			getCommandsByTypeLocal() {
				this.message = 'Estamos cargando los comandos . . .'
				this.getCommandsByType([0])
			},
			getCommandsByTypeResultLocal(response) {
				if(response.data.success == true) {
					this.setCommandSystem(response.data.data)
					console.log('Se recuperó con exito los commandos!!!')
					this.redirect()
				}
			},
			getMenus() {
				this.message = 'Estamos cargando Menus . . .'
				this.axios.get(this.getApiBackend + 'auth/getMenus', {
						headers: this.getHeaders
					})
					.then(response => {
						console.log('Se recuperó con exito sus menus!!!')
						this.setMenu(response.data)
						this.getMenuFatorites()
					})
					.catch(error => {
						console.log(error)
					})
			},
			passwordChanged() {
				this.message = 'Contraseña cambiada con exito!!!'
				setTimeout(() => {
					this.$refs.changePasswordModalComponent.$refs.btnCloseChangePasswordModalComponent.click()
				}, 1000)
				this.getMenus()
			},
			redirect() {
				let index = this.getUser.menu.map((el) => parseInt(el.id)).indexOf(31)
				let menu = (index > -1) ? this.getUser.menu[index].to : '/'
				this.message = 'Datos del usuario cargados, estamos redirigiendo al sistema'
				let redirect = (localStorage.getItem('redirect') != null) ? localStorage.getItem('redirect') : '/'

				/*redirect = (redirect == '/') ? menu : redirect
				console.log(localStorage.getItem('redirect'), redirect)

				index = this.getUser.menu.map((el) => el.to).indexOf(redirect)
				redirect = (index == -1 && redirect != '/') ? '/' : redirect

				console.log(el.to)
				alert('ya')*/
				localStorage.removeItem('redirect')
				setTimeout(() => {
					this.$router.push(redirect)
				}, 1000)
			},
			showChangePasswordModalComponent() {
				this.$refs.changePasswordModalComponent.$refs.btnShowChangePasswordModalComponent.click()
			},
		},
		mounted () {
			this.initLoading()
		},
	}	
</script>

<style lang="scss">
</style>
